<div style="color:#00857c;">
    <div id="error" style="margin-top: 20%;"></div>
    <div id="error_desc" style="text-align: center; font-size: 25px;">{{this.errorData.message}}</div>
</div>